<template>
  <b-row>
    <b-col cols="12">
      <form-cessao-direitos />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import FormCessaoDireitos from './FormCessaoDireitos.vue'

export default {
  name: 'CessaoDireitos',
  components: {
    BRow,
    BCol,
    FormCessaoDireitos
  },
}
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-wizard.scss';
  @import '@core/scss/vue/libs/vue-select.scss';
</style>
